import styles from './index.module.less';
import Image from 'next/image';
const Index = ({ alternativeBasic, websiteBasic, compareFeature }: any) => {
  return (
    <div className={styles.container}>
      <div className={styles.firstCompare}>
        <Image src={alternativeBasic.imgPath} alt={alternativeBasic.title} height={40} priority width={130} />
        <span>vs</span>
        <Image src={websiteBasic.imgPath} alt={websiteBasic.title} height={40} priority width={130} />
      </div>
      <h2 className={styles.title}>{compareFeature.title}</h2>
      <div className={styles.description}>{compareFeature.desc}</div>
      <div className={styles.table}>
        <ul className={styles.list}>
          <li>
            <div>Feature</div>
            <div>
              <Image src={websiteBasic.imgPath} alt={websiteBasic.title} height={31} priority width={100} />
            </div>
            <div>
              <Image src={alternativeBasic.imgPath} alt={alternativeBasic.title} height={31} priority width={100} />
            </div>
          </li>
          {compareFeature.values.map((item: any) => (
            <li>
              <div>{item.feature}</div>
              <div>{item.erasa}</div>
              <div>{item.alternative}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Index;
